module.exports = __webpack_public_path__ + "img/info.e66dd1a9.svg";